import { render, staticRenderFns } from "./TableHeaderCollectionFilter.vue?vue&type=template&id=19e40c86&scoped=true"
import script from "./TableHeaderCollectionFilter.vue?vue&type=script&lang=js"
export * from "./TableHeaderCollectionFilter.vue?vue&type=script&lang=js"
import style0 from "./TableHeaderCollectionFilter.vue?vue&type=style&index=0&id=19e40c86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e40c86",
  null
  
)

export default component.exports